import { useMemo, type ReactNode } from 'react'
import type { BrandKit } from './brand.types'
import { detectBrand } from './brandDetection'
import { BrandContext } from './brandContext'

interface BrandProviderProps {
  children: ReactNode
  /** Overrides host detection. Tests and Storybook only. */
  brand?: BrandKit
}

/**
 * Resolves the organization brand once per session and exposes it to the tree.
 * Must sit above ThemeProvider — the MUI palette is built from the brand.
 */
export const BrandProvider = ({ children, brand }: BrandProviderProps) => {
  const value = useMemo(() => brand ?? detectBrand(), [brand])

  return <BrandContext.Provider value={value}>{children}</BrandContext.Provider>
}
